import { render, staticRenderFns } from "./IntTab.vue?vue&type=template&id=1d5fc9a7"
import script from "./IntTab.vue?vue&type=script&lang=js"
export * from "./IntTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports